import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { t } from '../../../utils/textUtils';
import { prepareProjectProgressChartData } from '../utils/chartHelpers';

const ProjectProgressChart = ({ 
  selectedProject, 
  handleFilterChange, 
  dashboardOverviewData, 
  activeProjects 
}) => {
  const projectsToRender = dashboardOverviewData.runningProjects || activeProjects || [];
  
  return (
    <Box>
      <Paper
        variant="outlined"
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
          borderColor: 'divider',
          minHeight: '450px',
          bgcolor: '#ffffff'
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 1
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a' }}>
            {t('PROGRES PROYEK')}
          </Typography>
          <Box sx={{ minWidth: 200 }}>
            <label style={{ fontSize: '0.875rem', marginRight: '8px' }}>{t('FILTER PROYEK')}:</label>
            <select
              value={selectedProject}
              onChange={handleFilterChange}
              style={{
                fontSize: '0.875rem',
                padding: '8px',
                minWidth: '150px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                backgroundColor: 'white'
              }}
            >
              <option value="">{t('SEMUA PROYEK')}</option>
              {projectsToRender.map((p) => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </select>
          </Box>
        </Box>
        
        {projectsToRender.length > 0 ? (
          <Box sx={{ height: 200, mt: 2 }}>
            <Bar 
              data={prepareProjectProgressChartData(
                selectedProject 
                  ? projectsToRender.filter(p => p.id === selectedProject)
                  : projectsToRender
              )} 
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false,
                    position: 'top',
                    labels: {
                      boxWidth: 15,
                      usePointStyle: true,
                      pointStyle: 'circle'
                    }
                  },
                  tooltip: {
                    backgroundColor: 'rgba(26, 59, 110, 0.8)',
                    titleFont: { weight: 'bold' },
                    padding: 10,
                    cornerRadius: 4,
                    displayColors: true
                  }
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    max: 100,
                    title: {
                      display: true,
                      text: t('PROGRES (%)'),
                      font: { weight: 'bold' }
                    },
                    ticks: {
                      callback: function(value) {
                        return value + '%';
                      }
                    }
                  },
                  x: {
                    title: {
                      display: true,
                      text: t('PROYEK'),
                      font: { weight: 'bold' }
                    }
                  }
                }
              }}
            />
          </Box>
        ) : (
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            height: '300px'
          }}>
            <AccountTreeIcon sx={{ fontSize: 60, color: '#ccc', mb: 2 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              {t('TIDAK ADA PROYEK AKTIF DITEMUKAN')}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center" sx={{ maxWidth: 400 }}>
              {t('PROYEK YANG DITUGASKAN KEPADA ANDA AKAN MUNCUL DI SINI. PERIKSA IZIN ANDA ATAU HUBUNGI ADMIN.')}
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default ProjectProgressChart;
